
const APP_ROUTES = {
  LANDING: "/",
  BASKET: "/basket",
  POLICY: "/policy",
  PRIVACY: "/privacy",
  ABOUT: "/about",
  COOPRATION: "/opportunities",
  COOPRATION_FORM: "/form",
  FAQ: "/faq",
  DASHBOARD: "/dashboard",
  PROFILE: "/dashboard/profile",
  FAVORITES: "/dashboard/favorites",
  ORDERS: "/dashboard/orders",
  MY_CONTENT: "/dashboard/my-content/videos",
  VIDEOS: "",
  SUPPORT: "/dashboard/support",
  chat: (ticketId: string) => `/chat/${ticketId}`,
  dynamicSample: (productId: string) => `/dynamic-sample/${productId}/details`,
  FILTER: "/filter",
  ELEMENTRY_SCHOOL: "/filter?categories=1",
  MIDDLE_SCHOOL: "/filter?categories=2",
  HIGH_SCHOOL: "/filter?categories=3",
  FINAL_EXAM: "/filter?categories=4",
  KONKOOR: "/filter?categories=5",
  productDetails: (productId: string) => `/productDetails/${productId}`,
  CONTACT_US: "/contact",
  PRODUCT_DETIALS: `productDetails`,
  CATEGORIES: "/categories",
  LESSONS: "/lessons",
  KANGAROO: "/kangaroo",
  lEARNHOOSH:"/learn-hoosh",
  MathAcademy: "/math-academy",
  MathAcademyExam: "/math-academy/exam",
};
export default APP_ROUTES;
